module.exports = __webpack_public_path__ + "img/user_256x256.4cc8ba9f.png";